export const EMAIL_AUTOCOMPLETE_KEY = 'email-autocomplete';
export const ENTER_KEY = 'Enter';
